if (!customElements.get('full-width-element')) {
  customElements.define('full-width-element', class FullWidthElement extends HTMLElement {
    constructor() {
      super();
      this.resizeObserver = null;
    }

    connectedCallback() {
      this.setScrollbarWidth();
      this.watchForResize();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    setScrollbarWidth() {
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    }

    watchForResize() {
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === this) this.setScrollbarWidth();
        }
      });
      this.resizeObserver.observe(this);
    }
  });
}
